import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import { authGuard } from "src/lt-module/auth-module";
import Container from "../dinner-module/Container.vue";
// import { adminRoutes } from "../admin-module/adminRoutes";
import { adminRoutes } from "src/lt-module/admin-module";
import { storeRoutes } from "src/lt-module/store-module";

Vue.use(VueRouter);

const routes = [
  // authRoute,
  {
    path: "/login",
    component: () => import("../components/LoginPage.vue"),
    name: "login"
  },
  {
    path: "/",
    component: Container,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        component: () => import("../elvecino-module/Bienvenido.vue"),
        name: "home"
      },
      {
        path: "/store",
        meta: { requiresAuth: true },
        component: () => import("../dinner-module/Store.vue")
      },
      {
        path: "/diaries",
        component: () => import("../dinner-module/PageDiarie.vue")
      },
      {
        path: "/sales",
        meta: { requiresAuth: true },
        redirect: "/store/sales"
        // component: () => import("../store-module/sales/Index.vue")
      },
      {
        path: "/products",
        meta: { requiresAuth: true },
        redirect: "/store/products"
        // component: () => import("../store-module/products/Index.vue")
      },
      {
        path: "/report",
        meta: { requiresAuth: true },
        component: () => import("../dinner-module/Report.vue")
      },
      {
        path: "/chicken",
        meta: { requiresAuth: true },
        component: () => import("../elvecino-module/ControlPollo.vue")
      },
      {
        path: "/clients",
        meta: { requiresAuth: true },
        redirect: "/store/clients"
        // component: () => import("../store-module/clients/Index.vue")
      },
      {
        path: "/permissions",
        meta: { requiresAuth: true },
        component: () => import("../components/Permissions.vue")
      },
      {
        path: "/to-make",
        meta: { requiresAuth: true },
        component: () => import("../dinner-module/Services.vue")
      },
      {
        path: "/maked",
        meta: { requiresAuth: true },
        component: () => import("../dinner-module/MakedQueue.vue")
      },
      {
        path: "/pending-sales",
        component: () => import("../components/PendingSalesPage.vue"),
        name: "pending-sales"
      },
      storeRoutes,
      adminRoutes
    ]
  },

  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach(authGuard);

export default router;
